import React from 'react';
import './styles.css';

const LoginHeader = () => {
  return (
    <div className="header-container">
      
      <div className="text-container">
        HỆ THỐNG NHẮN TIN TRỰC TUYẾN<br />
      </div>
    </div>
  );
};
export default LoginHeader;
